import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import PageHeader from '../components/PageHeader';
import usePageSearchIndex from '../hooks/usePageSearchIndex';
import './TendersNotices.css';

const TendersNotices = () => {
  const { isMarathi } = useLanguage();

  usePageSearchIndex({
    mr: ['निविदा', 'सूचना', 'टेंडर', 'नोटिस'],
    en: ['tenders', 'notices', 'tender', 'notice']
  });

  const [selectedYear, setSelectedYear] = useState('2026');

  const pageHeaderData = {
    title: {
      marathi: 'विभागीय निविदा आणि सूचना',
      english: 'Departmental Tenders & Notices'
    },
    subtitle: {
      marathi: 'महाराष्ट्र कामगार कल्याण मंडळाच्या निविदा व सूचना',
      english: 'Tenders and Notices of Maharashtra Labour Welfare Board'
    }
  };

  const content = {
    marathi: {
      lastUpdated: 'शेवटचे अपडेट: 23 जानेवारी 2026',
      tableHeaders: {
        details: 'निविदा व सूचनेचा तपशिल',
        moreInfo: 'अधिक माहिती',
        publishDate: 'प्रसिद्धी दिनांक',
        lastDate: 'अंतिम स्विकृती दिनांक'
      }
    },
    english: {
      lastUpdated: 'Last Updated: January 23, 2026',
      tableHeaders: {
        details: 'Tender & Notice Details',
        moreInfo: 'More Information',
        publishDate: 'Publication Date',
        lastDate: 'Last Date for Submission'
      }
    }
  };

  // Sample data for different years
  const tendersData = {
    2026: [
      {
        id: 1,
        details: {
          marathi: "महाराष्ट्राने नवीन 'औद्योगिक संबंध संहिते'अंतर्गत राज्य नियमावली अधिसूचित केली आहे. तुमचा अभिप्राय महत्त्वाचा आहे - तुमच्या सूचना १२.०६.२०२६ पर्यंत सादर करा.",
          english: 'Maharashtra notified State Rules under the New Industrial Relations Code. Your feedback matters - submit your suggestions by 12.06.2026'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '28/04/2026',
        lastDate: '12/06/2026',
        link: 'https://mlwb.in//react-static-files/pdf/tenders-and-notices/2026/04/1_Code_on_IR_Draft_Rules_2026.pdf'
      },
      {
        id: 2,
        details: {
          marathi: "महाराष्ट्राने नवीन 'वेतन संहिते'अंतर्गत राज्य नियम अधिसूचित केले आहेत. तुमचा अभिप्राय महत्त्वाचा आहे – तुमच्या सूचना १२.०६.२०२६ पर्यंत सादर करा.",
          english: 'Maharashtra notified State Rules under the New Wages Code. Your feedback matters - submit your suggestions by 12.06.2026'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '28/04/2026',
        lastDate: '12/06/2026',
        link: 'https://mlwb.in//react-static-files/pdf/tenders-and-notices/2026/04/2_Code_on_Wages_Draft_Rules_2026_Published.pdf'
      },
      {
        id: 3,
        details: {
          marathi: 'कामगार कल्याण भवन, राजे रघुजीनगर, नागपूर येथील जलतरण तलावाचे संचालन व देखभाल कामाकरिता एजन्सी नियुक्त करणे.',
          english: 'Appointment of an agency for the operation and maintenance of the swimming pool at Kamgar Kalyan Bhavan, Raje Raghuji Nagar, Nagpur.'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '18/02/2026',
        lastDate: '10/03/2026',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2026/02/Appointment_of_an_agency_for_the_operation_and_maintenance_of_the_swimming_pool_at_MLWB_Nagpur.pdf'
      },
      {
        id: 4,
        details: {
          marathi: '४३ मंत्रालयीन सचिवांचे सामान्य प्रशासन विभागाकडून करण्यात येणारे गुणांकन : सेवाविषयक आढावा - महाराष्ट्र कामगार कल्याण मंडळ',
          english: 'Performance evaluation of 43 ministerial secretaries by the General Administration Department: Service review - Maharashtra Labour Welfare Board'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '23/01/2026',
        lastDate: 'NA',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2026/01/sevavishayak_aadhava_maharashtra_kamgar_kalyan_mandal_23012026.pdf'
      }
    ],
    2025: [
      {
        id: 1,
        details: {
          marathi: 'अधिसूचना - दि.24 सप्टेंबर 2025 - महाराष्ट्र कामगार कल्याण मंडळाची पुनर्रचना होईपर्यंत उपसचिव (कामगार 10) यांची मंडळाचे अधिकार व कार्ये पार पाडण्यासाठी नियुक्ती करणेबाबत.',
          english: 'Notification - Dt. 24 September 2025 - Regarding appointment of Deputy Secretary (Labour 10) to carry out the powers and functions of the Board until the restructuring of Maharashtra Labour Welfare Board.'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '24/09/2025',
        lastDate: 'NA',
        link:  'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2025/09/20250928-mlwb-power-delegation.pdf'
      }
    ],
    2024: [],
    2023: [
      {
        id: 1,
        details: {
          marathi: '१७ वे राज्यस्तरीय कामगार साहित्य संमेलन, मिरज जि. सांगली - दि. २४ ते २५ फेब्रुवारी २०२३',
          english: '17th State Level Workers Literature Conference, Miraj Dist. Sangli - Date 24th to 25th February 2023'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '11/01/2023',
        lastDate: '31/01/2023',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2023/02/20230208_rajyastariy_kamgar_sahitya_sanmmelan_miraj_sangali.pdf'
      },
      {
        id: 2,
        details: {
          marathi: 'ई निविदा - धनुर्विद्या खेळाचे साहित्य खरेदी करणेबाबत',
          english: 'E-Tender - Regarding the purchase of archery equipment'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '09/01/2023',
        lastDate: '23/01/2023',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2023/01/20230111_enivida_dhanurvidya_khelache_sahitya_kharedi_karnebabat.pdf'
      },
      {
        id: 3,
        details: {
          marathi: 'ई निविदा - रायफल शुटींग खेळाचे साहित्य खरेदी करणेबाबत',
          english: 'E-Tender - Regarding the purchase of rifle shooting equipment'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '09/01/2023',
        lastDate: '23/01/2023',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2023/01/20230111_enivida_rifle_shooting_khelache_sahitya_kharedi_karnebabat.pdf'
      },
      {
        id: 4,
        details: {
          marathi: 'धनुर्विद्या खेळाचे भारतीय बनावटीचे साहित्य खरेदी करणेबाबत',
          english: 'Regarding the purchase of Indian-made archery equipment'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '09/01/2023',
        lastDate: '21/01/2023',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2023/01/20230111_dhanurvidya_khelache_bhartiy_banavatiche_sahitya_kharedi_karanebabat.pdf'
      }
    ],
    2022: [
      {
        id: 1,
        details: {
          marathi: 'जाहीर प्रकटन - पडीक भंगार विक्रीसाठी दरपत्रके मागविण्याबाबत',
          english: 'Public Notice - Regarding inviting quotations for sale of scrap metal'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '08/12/2022',
        lastDate: '14/12/2022',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2022/12/20221209_padik_bhangar_vikrisathi_darpatrake_magavinyababat.pdf'
      },
      {
        id: 2,
        details: {
          marathi: 'जाहीर प्रकटन - मंडळाचे प्रशासकीय वार्षिक अहवाल छपाईकरिता दरपत्रक सादर करणेबाबत',
          english: 'Public Notice - Regarding submission of quotations for printing of Administrative Annual Report of the Board'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '06/12/2022',
        lastDate: '12/12/2022',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2022/12/20221208_mandalache_prashasakiya_varshik_ahaval_chapaikarita_darpatrak_sadar_karnebabat.pdf'
      },
      {
        id: 3,
        details: {
          marathi: 'औद्योगिक व व्यावसायिक कामगारांसाठी २६ वी आणि महिलांसाठी २१ वी खुली राज्यस्तरीय कबड्डी स्पर्धा २०२२-२३',
          english: '26th Open State Level Kabaddi Competition for Industrial and Professional Workers and 21st Open State Level Kabaddi Competition for Women 2022-23'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '17/11/2022',
        lastDate: '16/01/2023',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2022/11/20221217_paripatrak_audyogik_&_vyvsayik_kamgar_&_mahilansathi_khuli_rajysatriya_kabaddi_spardha_2022_23.pdf'
      },
      {
        id: 4,
        details: {
          marathi: 'जिल्हा नियोजन समिती, मुंबई शहर यांच्या निधीतून हुतात्मा बाबू गेनू मुंबई गिरणी कामगार क्रीडा भवन, प्रभादेवी येथे आर्चरी ट्रेनिंग सेंटर उभारणेबाबत',
          english: 'Regarding establishment of Archery Training Center at Hutatma Babu Genu Mumbai Girni Kamgar Krida Bhavan, Prabhadevi from the funds of District Planning Committee, Mumbai City'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '21/10/2022',
        lastDate: '04/11/2022',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2022/10/20221021_archery_training_center_ubharnyababat.pdf'
      },
      {
        id: 5,
        details: {
          marathi: 'आर्चरी ट्रेनिंग सेंटर व रायफल शूटींग ट्रेनिंग सेंटर उभारणीच्या स्थापत्य कामांचे नियोजन करण्यासाठी वास्तुविशारद नियुक्त करणेबाबत',
          english: 'Regarding appointment of architect to plan the construction work of construction of Archery Training Center and Rifle Shooting Training Center'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '30/07/2022',
        lastDate: '08/08/2022',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2022/08/20220813_training_center_ubharnichya_sthapatya_kamanche_niyojan_karnyasathi_vastuvisharad_niyuktti.pdf'
      },
      {
        id: 6,
        details: {
          marathi: 'महाराष्ट्र कामगार कल्याण मंडळ, प्रभादेवी मुंबई येथील उद्वाहन क्रमांक 1 चा वार्षिक देखभाल ठेक्यासाठी दरपत्रक सादर करणेबाबत',
          english: 'Regarding submission of quotations for annual maintenance contract of Lift No. 1 at Maharashtra Kamgar Kalyan Mandal, Prabhadevi Mumbai'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '07/07/2022',
        lastDate: '22/07/2022',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2022/07/07072022_mlwb_prabhadevi_mumbai_udvahan_kramank_1_cha_varshik_dekhbhal_thekyasathi_darpatrak_sadar_karanebabat.pdf'
      },
      {
        id: 7,
        details: {
          marathi: 'पावसाळ्याच्या अनुषंगाने करावयाची विविध दुरुस्ती कामे - ठेकेदार नियुक्त करणेबाबत',
          english: 'Regarding appointment of various repair works to be done in connection with the monsoon season - Regarding appointment of contractors'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '28/06/2022',
        lastDate: '06/07/2022',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2022/07/20220721_pavsalyachya_anushangane_karavayachi_vividh_durusti_kame_thekedar_niyuktti.pdf'
      },
      {
        id: 8,
        details: {
          marathi: 'अवितरीत संचयन रकमांची सूचना - जून २०२२',
          english: 'Notice of undistributed accumulation amounts - June 2022'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '01/06/2022',
        lastDate: 'NA',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2022/06/20220702_avitarit_sanchyan_rakamanchi_suchana_june_2022.pdf'
      },
      {
        id: 9,
        details: {
          marathi: 'मुंबई शहर व परिसरातील महाराष्ट्र कामगार कल्याण मंडळाच्या इमारतींच्या देखभाल व दुरुस्ती कामांबाबत - वास्तुविशारद नियुक्ती करणेबाबत',
          english: 'Regarding maintenance and repair works of Maharashtra Workers Welfare Board buildings in Mumbai city and vicinity - Regarding appointment of architect'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '30/06/2022',
        lastDate: '08/07/2022',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2022/06/20220630_mumbai_shahar_v_parisaratil_mlwb_imaratichya_dekhbhal_v_durustibabat_vastuvisharad_niyukti.pdf'
      },
      {
        id: 10,
        details: {
          marathi: 'पावसाळ्याच्या अनुषंगाने करावयाची विविध दुरुस्ती कामे - वास्तुविशारद नियुक्त करणेबाबत',
          english: 'Various repair works to be done in connection with the monsoon season - Regarding appointment of architect'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '10/06/2022',
        lastDate: '18/06/2022',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2022/06/20220630_pavsalyachya_anushangane_karavayachi_vividh_durusti_kame_vastuvisharad_niyuktti.pdf'
      },
      {
        id: 11,
        details: {
          marathi: 'मुंबई शहर व परिसरातील महाराष्ट्र कामगार कल्याण मंडळाच्या ४ इमारतींचे स्ट्रक्टरल ऑडिट करणेबाबत',
          english: 'Regarding structural audit of 4 buildings of Maharashtra Workers Welfare Board in Mumbai city and vicinity'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '11/05/2022',
        lastDate: '19/05/2022',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2022/05/20220512_structural_audit_of_4_bldg_of_mlwb.pdf'
      },
      {
        id: 12,
        details: {
          marathi: 'मुंबई शहर परिसरातील २ कामांसाठी नोंदणीकृत कंत्राटदारांकडून निविदा मागविणेबाबत',
          english: 'Regarding inviting tenders from registered contractors for 2 works in Mumbai city and vicinity'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '24/02/2022',
        lastDate: '10/03/2022',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2022/02/20220228_mumbai_shahar_parisaratil_2_kamansathi_nivida_magavinebabat.pdf'
      },
      {
        id: 13,
        details: {
          marathi: 'मंडळाचे वाहन क्रमांक MH 01 AR 8187 जसे आहे, जेथे आहे तसे निकाली काढण्यासाठी निविदा मागविणेबाबत',
          english: 'Regarding inviting tenders to settle the vehicle number of the board MH 01 AR 8187 as is, where is'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '19/02/2022',
        lastDate: '03/03/2022',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2022/02/20220222_MH01AR8187_nikali_kadhanyasathi_nivida_magavinebabat.pdf'
      },
      {
        id: 14,
        details: {
          marathi: 'प्रभादेवी व अभ्युदय नगर मुंबई येथील दुरुस्ती / स्थापत्य कामांसाठी वास्तुविशारद यांचेकडून दरपत्रक मागविणेबाबत',
          english: 'Regarding inviting quotations from architects for repair / construction works in Prabhadevi and Abhyudaya Nagar Mumbai'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '14/02/2022',
        lastDate: '21/02/2022',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2022/02/20220217_vastuvisharad_yanchekadun_darpatrak_magavinebabat.pdf'
      },
      {
        id: 15,
        details: {
          marathi: 'कामगार कल्याण भवन, उस्मानाबाद येथील इमारतीचे स्ट्रक्चरल ऑडिट करण्यासाठी दरपत्रक सादर करणेबाबत',
          english: 'Regarding submission of quotations for structural audit of the building at Kamgar Kalyan Bhavan, Usmanabad'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '04/02/2022',
        lastDate: '10/02/2022',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2022/02/20220204_structural_audit_of_kamgar_kalyan_bhavan_osmanabad.pdf'
      },
      {
        id: 16,
        details: {
          marathi: 'अग्निशमन यंत्र पुरवण्यासाठी दरपत्रक सादर करणेबाबत',
          english: 'Regarding submission of quotations for supply of fire extinguishers'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '29/01/2022',
        lastDate: '05/02/2022',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2022/01/20220129_agnikshaman_yantra_kharedi_karnebabat.pdf'
      }
    ],
    2021: [
      {
        id: 1,
        details: {
          marathi: 'कामगार कल्याण भवन, अभ्युदय नगर, काळाचौकी, मुंबई येथील धोकादायक इमारतीच्या पाडकामाकरीता नोंदणीकृत पाडकाम ठेकेदारांकडून दरपत्रक मागविणेबाबत.',
          english: 'Regarding requesting quotations from registered demolition contractors for demolition of dangerous building at Kamgar Kalyan Bhavan, Abhyudaya Nagar, Kalachowki, Mumbai'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '15/11/2021',
        lastDate: '20/11/2021',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2021/11/20211115_invitation_of_quotation_for_demolition_bldg_mlwb_kalachouki_mumbai.pdf'
      },
      {
        id: 2,
        details: {
          marathi: 'कामगार कल्याण भवन, अभ्युदय नगर, काळाचौकी, मुंबई येथील इमारतीच्या पाडकामाची प्रक्रिया करण्याकरिता लायसन्स स्ट्रक्चरल इंजिनिअर नियुक्त करणेबाबत',
          english: 'Regarding appointing a licensed structural engineer to process the demolition of the building at Kamgar Kalyan Bhavan, Abhyudaya Nagar, Kalachowki, Mumbai'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '26/10/2021',
        lastDate: '30/10/2021',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2021/10/20211026_mlwb_kalachowki_mumbai_structural_engineer_niyuktta_karnebabat.pdf'
      },
      {
        id: 3,
        details: {
          marathi: 'कामगार क्रीडा भवन, प्रभादेवी, मुंबई येथील मैदानातील गवत कापण्याबाबत.',
          english: 'Regarding cutting the grass in the ground at Kamgar Krida Bhavan, Prabhadevi, Mumbai'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '20/09/2021',
        lastDate: '28/09/2021',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2021/09/20210920_mlwb_prabhadevi_mumbai_maidanatil_gavat_kapnyababat.pdf'
      },
      {
        id: 4,
        details: {
          marathi: 'कामगार कल्याण भवन, अभ्युदय नगर, काळाचौकी, मुंबई येथील इमारतीचे स्ट्रक्चरल ऑडिट करणेबाबत',
          english: 'Regarding conducting structural audit of the building at Kamgar Kalyan Bhavan, Abhyudaya Nagar, Kalachowki, Mumbai'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '29/07/2021',
        lastDate: '04/08/2021',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2021/07/20210729_structural_audit_of_mlwb_kalachowki_mumbai.pdf'
      },
      {
        id: 5,
        details: {
          marathi: 'अवितरीत संचयन रक्कम नोटीस - जून २०२१',
          english: 'Notice of undistributed accumulation amount - June 2021'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '01/06/2021',
        lastDate: 'NA',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2021/06/2021_avitarit_sanchyan_rakkam_notice_june.pdf'
      },
      {
        id: 6,
        details: {
          marathi: 'एमएलडब्ल्यूबी नवीन प्रशासकीय इमारत, प्रभादेवी, मुंबई येथे विविध दुरुस्ती कामांसाठी दरपत्रक',
          english: 'Quotation for various repair works at MLWB new administration building, Prabhadevi, Mumbai'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '04/06/2021',
        lastDate: '11/06/2021',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2021/06/20210604_quotation_for_various_repair_work_at_mlwb_new_admin_building_Mumbai.pdf'
      },
      {
        id: 7,
        details: {
          marathi: 'एमएलडब्ल्यूबी नवीन प्रशासकीय इमारत, प्रभादेवी, मुंबई येथे नळजोडणी कामासाठी दरपत्रक सादर करणेबाबत',
          english: 'Regarding submission of quotation for plumbing work at Administrative Building, Prabhadevi, Mumbai'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '03/06/2021',
        lastDate: '07/06/2021',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2021/06/20210603_prashaskiy_imarat_mumbai_naljodani_kamasathi_darpatrak.pdf'
      },
      {
        id: 8,
        details: {
          marathi: 'श्रमकल्याण युग या मराठी मासिकाची निर्मिती बाबत',
          english: 'Regarding production of Marathi magazine Shram Kalyan Yug'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '05/04/2021',
        lastDate: '19/04/2021',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2021/04/20210409_shram_kalyan_yug_masikachi_nirmiti.pdf'
      },
      {
        id: 9,
        details: {
          marathi: 'श्रमकल्याण युग पुरस्कार विशेषांक छपाईसाठी दरपत्रक मागविणे बाबत',
          english: 'Regarding requesting quotation for printing of Shram Kalyan Yug Award Special Issue'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '15/01/2021',
        lastDate: '22/01/2021',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2021/01/20210115_shramkalyan_yug_puraskar_visheshank_chapaisathi_darpattrak_magavinebabat.pdf'
      }
    ],
    2020: [
      {
        id: 1,
        details: {
          marathi: 'अवितरित समुच्चय नोटीस - डिसेंबर २०२०',
          english: 'Undistributed aggregate notice - December 2020'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '01/12/2020',
        lastDate: 'NA',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2020/12/avitarit_sanchyan_rakkam_notice_dec_2020.pdf'
      },
      {
        id: 2,
        details: {
          marathi: 'अविरत संचलन एकत्रित नोटीस',
          english: 'Continuous movement aggregate notice'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '01/06/2020',
        lastDate: 'NA',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2020/06/avitarit_sanchyan_rakkam_notice_june_2020.pdf'
      },
      {
        id: 3,
        details: {
          marathi: 'संरक्षक आवार भिंत उभारणी',
          english: 'Construction of protective enclosure wall'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '02/03/2020',
        lastDate: '12/03/2020',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2020/03/sanrakshak_aavar_bhint_ubharnyababat_022020.pdf'
      },
      {
        id: 4,
        details: {
          marathi: 'सिग्नल केसरी व कुमार केसरी कुस्ती तारीख - दिनांक २५ व २६ फेब्रुवारी २०२०',
          english: 'Signal Kesari and Kumar Kesari wrestling date - Date 25 and 26 February 2020'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '13/02/2020',
        lastDate: 'NA',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2020/02/KustiForm_2020.pdf'
      },
      {
        id: 5,
        details: {
          marathi: 'राज्य कबड्डी - फेब्रुवारी २०२०',
          english: 'State Kabaddi - February 2020'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '12/02/2020',
        lastDate: '16/02/2020',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2020/01/kabaddi_spardha_feb_2020.pdf'
      },
      {
        id: 6,
        details: {
          marathi: 'संगणकीय प्रणालीद्वारे महाराष्ट्र उन्नती भरणा करणे',
          english: 'Maharashtra Unnati payment through computer system'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '01/01/2020',
        lastDate: 'NA',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2020/01/sanganakiy_pranalidware_maharashtra_kamgar_kalyan_nidhi_bharana_karane_babat_012020.pdf'
      }
    ],
    2019: [
      {
        id: 1,
        details: {
          marathi: 'महाराष्ट्र कामगार कल्याण निधी अधिनियम १९५३ च्या कलम ६ (अ) (३) अन्वये प्रसिद्ध सूचना - डिसेंबर २०१९',
          english: 'Notice published under Section 6 (a) (3) of the Maharashtra Workers Welfare Fund Act, 1953 - December 2019'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '01/12/2019',
        lastDate: 'NA',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2019/12/maharashtra_kamgar_kalyan_nidhi_adhiniyam_1953_kalam_6a_december_2019_012020.pdf'
      },
      {
        id: 2,
        details: {
          marathi: 'कामगार क्रीडा भवन, प्रभादेवी रेल्वे स्टेशनजवळ, मुंबई येथील संरक्षण आवार भिंत बांधण्याबाबत',
          english: 'Regarding construction of protective enclosure wall at Kamgar Krida Bhavan, near Prabhadevi Railway Station, Mumbai'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '17/12/2019',
        lastDate: '07/01/2020',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2019/12/sanrakshan_aavar_bhint_bandhanyababat_122019.pdf'
      },
      {
        id: 3,
        details: {
          marathi: 'विश्वकर्मा आदर्श कामगार पुरस्कार २०१९ व कामगार भूषण पुरस्कार २०१९ - अर्ज',
          english: 'Vishwakarma Adarsh Kamgar Puraskar 2019 and Kamgar Bhushan Puraskar 2019 - Application'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '25/10/2019',
        lastDate: '30/11/2019',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2019/10/viswakarma_adarsh_kamgar_puraskar_kamgar_bhushan_puraskar_form_102019.pdf'
      },
      {
        id: 4,
        details: {
          marathi: 'कामगार क्रीडा भवन, प्रभादेवी, मुंबई येथील भूखंडावर जाहिरात फलक लावणेबाबत',
          english: 'Regarding putting up of advertisement board on plot at Kamgar Krida Bhavan, Prabhadevi, Mumbai'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '31/08/2019',
        lastDate: '09/09/2019',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2019/09/jahiratiche_falak_092019.pdf'
      },
      {
        id: 5,
        details: {
          marathi: 'कामगार भूषण पुरस्कार व गुणवंत कामगार कल्याण पुरस्कार २०१७ - अंतिम निवड यादी',
          english: 'Kamgar Bhushan Puraskar and Gunwant Kamgar Kalyan Puraskar 2017 - Final selection list'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '01/07/2019',
        lastDate: 'NA',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2019/07/gunvant_bhushan_gunvant_kamgar_kalyan_puraskar_2017_final_list_17072019.pdf'
      },
      {
        id: 6,
        details: {
          marathi: 'महाराष्ट्र कामगार कल्याण मंडळाचे कॅन्टीन चालविण्याबाबत',
          english: 'Regarding running of canteen of Maharashtra Workers Welfare Board'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '27/06/2019',
        lastDate: '19/07/2019',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2019/07/canteen_chalavanyasathi_enivida_july_2019.pdf'
      },
      {
        id: 7,
        details: {
          marathi: 'अवितरीत संचयन रकमेची वर्गीकृत जाहिरात - जून २०१९',
          english: 'Classified advertisement of undistributed accumulation amount - June 2019'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '01/06/2019',
        lastDate: 'NA',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2019/07/avitarit_sanchayan_rakamechi_vargikrut_jahirat_june_2019.pdf'
      },
      {
        id: 8,
        details: {
          marathi: 'Selection of Managed Service Provider चे टेंडर',
          english: 'Tender for Selection of Managed Service Provider'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '18/02/2019',
        lastDate: '05/03/2019',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2019/02/tender_of_Selection_of_manage_service_provider_18022019.pdf'
      },
      {
        id: 9,
        details: {
          marathi: 'Video Conferencing चे टेंडर',
          english: 'Tender for Video Conferencing'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '16/02/2019',
        lastDate: '04/03/2019',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2019/02/tender_of_video%20conferencing_25022019.pdf'
      },
      {
        id: 10,
        details: {
          marathi: 'मंडळाच्या विविध प्रकल्पातील हॉल मोनोपॉली तत्वावर देण्याबाबत',
          english: 'Regarding giving halls in various projects of the Board on monopoly basis'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '06/02/2019',
        lastDate: '01/03/2019',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2019/02/mandalachya_vividha_prakalpatil_hall_monopoly_tatvavar_denyababat_2019.pdf'
      },
      {
        id: 11,
        details: {
          marathi: 'मंडळाच्या १२ केंद्रातील दुरुस्तीसाठी निविदा मागविणेबाबत',
          english: 'Regarding inviting tenders for repairs in 12 centers of the Board'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '30/01/2019',
        lastDate: '07/02/2019',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2019/01/Mandalachya_12_kendranmadhe_vividh_durusti_kamamnbabat.pdf'
      },
      {
        id: 12,
        details: {
          marathi: 'एअर कंडिशनर्स आणि वॉटरकूलर्स यांची वार्षिक देखभाल करण्याबाबत',
          english: 'Regarding annual maintenance of air conditioners and water coolers'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '21/01/2019',
        lastDate: '30/01/2019',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2019/01/ac_watercooler_etender_jan_2019.pdf'
      },
      {
        id: 13,
        details: {
          marathi: 'नागपूर येथील भवनासाठी उद्वाहन (लिफ्ट) बसविण्याबाबत',
          english: 'Regarding installation of elevator for the building in Nagpur'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '20/01/2019',
        lastDate: '27/01/2019',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2019/01/lift_etender_nagpur_jan_2019.pdf'
      },
      {
        id: 14,
        details: {
          marathi: 'महाराष्ट्र कामगार कल्याण मंडळाचे कॅन्टीन चालविण्याबाबत',
          english: 'Regarding running the canteen of Maharashtra Workers Welfare Board'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '20/01/2019',
        lastDate: '27/01/2019',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2019/01/canteen_etender_jan_2019.pdf'
      },
      {
        id: 15,
        details: {
          marathi: 'जाहिरात फलक लावण्यासाठी दरपत्रक सादर करण्याबाबत जानेवारी २०१९',
          english: 'Regarding submission of price list for putting up advertisement boards January 2019'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '19/01/2019',
        lastDate: '28/01/2019',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2019/01/jahirat_falak_lavanyasathi_darpatrak_sadar_karnyababat_jan_2019.pdf'
      },
      {
        id: 16,
        details: {
          marathi: 'जुने वाहन विक्री सूचना',
          english: 'Notice for sale of old vehicles'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '14/01/2019',
        lastDate: 'NA',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2019/01/june_vahan_vikri_suchana.pdf'
      },
      {
        id: 17,
        details: {
          marathi: 'लेखन साहित्य ई-निविदा सूचना',
          english: 'Writing Materials e-Tender Notice'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '07/01/2019',
        lastDate: '19/01/2019',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2019/01/lekhan_sahitya_e_nivida_suchana.pdf'
      }
    ],
    2018: [
      {
        id: 1,
        details: {
          marathi: 'अवितरीत संचयन रकमेची डिसेंबर २०१८ ची सूचना',
          english: 'Notice of Undistributed Accumulation Amount December 2018'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '01/12/2018',
        lastDate: 'NA',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2018/avitarit_sanchayan_rakmechi_december_2018_suchana.pdf'
      },
      {
        id: 2,
        details: {
          marathi: 'नागपूर अग्नि प्रतिबंधक व्यवस्था',
          english: 'Nagpur Fire Prevention System'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '13/12/2018',
        lastDate: '27/12/2018',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2018/nagpur_agni_pratibandhak_vyavastha.pdf'
      },
      {
        id: 3,
        details: {
          marathi: 'नागपूर जलतरण तलाव दुरुस्ती',
          english: 'Nagpur Swimming Pool Repair'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '13/12/2018',
        lastDate: '27/12/2018',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2018/nagpur_jaltaran_talav_durusti.pdf'
      },
      {
        id: 4,
        details: {
          marathi: 'मंडळाच्या १२ केंद्रांमध्ये विविध दुरुस्ती कामांबाबत',
          english: 'Regarding various repair works in 12 centers of the Board'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '05/11/2018',
        lastDate: '13/11/2018',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2018/Mandalachya_12_kendranmadhe_vividh_durusti_kamamnbabat.pdf'
      },
      {
        id: 5,
        details: {
          marathi: 'मौजा हरपूर, नागपूर येथील क्रीडा संकुलाचे उर्वरित बांधकाम करणेबाबत',
          english: 'Regarding the remaining construction of the sports complex at Mauja Harpur, Nagpur'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '14/07/2018',
        lastDate: '09/08/2018',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2018/Mauja_harpur_nagpur_yethil_krida_sankulnache_urvarit_bandhkam_karanebabat.pdf'
      },
      {
        id: 6,
        details: {
          marathi: 'बडनेरा जि.अमरावती प्रकल्पासाठी वास्तुविशारद नियुक्तीबाबत',
          english: 'Regarding the appointment of an architect for the Badnera Dist. Amravati project'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '19/05/2018',
        lastDate: '11/06/2018',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2018/Badodara_jillha_amravati_prakalpasathi_vastuvisharad_niyuktibabad.pdf'
      },
      {
        id: 7,
        details: {
          marathi: 'गट आरोग्य विमा आणि वैयक्तीक अपघात विमा',
          english: 'Group Health Insurance and Personal Accident Insurance'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '17/05/2018',
        lastDate: '28/05/2018',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2018/Gat_aarogya_aani_vaiyaktik_apaghat_vima.pdf'
      }
    ],
    2017: [],
    2016: [
      {
        id: 1,
        details: {
          marathi: 'स्थापत्य अभियंता ( कंत्राटी ) नेमणूक',
          english: 'Appointment of Civil Engineer (Contract)'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '07/06/2016',
        lastDate: '16/06/2016',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2016/Sthaptya_abhiyanta_advt.pdf'
      },
      {
        id: 2,
        details: {
          marathi: 'रजिस्टर्स, फॉर्म छपाई',
          english: 'Registrations, Form Printing'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '30/05/2016',
        lastDate: '07/06/2016',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2016/Ragistration_form_printing_tender_notice.pdf'
      },
      {
        id: 3,
        details: {
          marathi: 'शिवण मशिन पुरवठा - ई निविदा',
          english: 'Supply of Sewing Machine - E-Tender'
        },
        moreInfo: {
          marathi: 'विवरणासाठी क्लिक करा',
          english: 'Click for Details'
        },
        publishDate: '20/05/2016',
        lastDate: '30/05/2016',
        link: 'https://mlwb.in/react-static-files/pdf/tenders-and-notices/2016/Shivan_machin_puravatha_e-tender.pdf'
      }
    ]
  };

  const currentContent = isMarathi() ? content.marathi : content.english;
  const availableYears = Object.keys(tendersData).sort((a, b) => b - a); // Sort years in descending order
  const currentYearData = tendersData[selectedYear] || [];

  // Helper function to convert English numerals to Marathi numerals
  const convertToMarathiNumerals = (number) => {
    const marathiNumerals = ['०', '१', '२', '३', '४', '५', '६', '७', '८', '९'];
    return number.toString().split('').map(digit => marathiNumerals[parseInt(digit)]).join('');
  };

  // Helper function to format date based on language
  const formatDate = (dateString) => {
    if (!dateString || dateString === 'NA') return dateString;
    
    if (isMarathi()) {
      // Convert DD/MM/YYYY to Marathi numerals
      return dateString.split('/').map(part => convertToMarathiNumerals(part)).join('/');
    }
    return dateString;
  };

  const handleYearClick = (year) => {
    setSelectedYear(year);
  };

  return (
    <div className="tenders-notices-container">
        {/* Page Header */}
        <PageHeader 
          title={pageHeaderData.title}
          subtitle={pageHeaderData.subtitle}
        />

        <div className="tenders-notices-content" data-read-section="tenders-notices-content">
          <div className="tenders-notices-layout">
            {/* Year Filter Sidebar */}
            <div className="year-filter-sidebar">
              <h3 className="year-filter-title">
                {isMarathi() ? 'वर्ष' : 'Year'}
              </h3>
              <div className="year-filter-list">
                {availableYears.map((year) => (
                  <button
                    key={year}
                    className={`year-filter-item ${selectedYear === year ? 'active' : ''}`}
                    onClick={() => handleYearClick(year)}
                  >
                    {year}
                  </button>
                ))}
              </div>
            </div>

            {/* Main Content */}
            <div className="tenders-notices-main">
              <div className="tenders-notices-table-container">
                <table className="tenders-notices-table">
                  <thead>
                    <tr>
                      <th>{currentContent.tableHeaders.details}</th>
                      <th>{currentContent.tableHeaders.moreInfo}</th>
                      <th>{currentContent.tableHeaders.publishDate}</th>
                      <th>{currentContent.tableHeaders.lastDate}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentYearData.length > 0 ? (
                      currentYearData.map((tender) => (
                        <tr key={tender.id}>
                          <td className="tender-details">
                            {tender.details[isMarathi() ? 'marathi' : 'english']}
                          </td>
                          <td className="tender-more-info">
                            <a 
                              href={tender.link} 
                              target="_blank" 
                              rel="noopener noreferrer"
                              className="tender-link"
                              aria-label={tender.moreInfo[isMarathi() ? 'marathi' : 'english']}
                            >
                              <svg 
                                width="18" 
                                height="18" 
                                viewBox="0 0 24 24" 
                                fill="none" 
                                stroke="currentColor" 
                                strokeWidth="2" 
                                strokeLinecap="round" 
                                strokeLinejoin="round"
                                className="document-icon"
                              >
                                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                                <polyline points="14,2 14,8 20,8"/>
                                <line x1="16" y1="13" x2="8" y2="13"/>
                                <line x1="16" y1="17" x2="8" y2="17"/>
                                <polyline points="10,9 9,9 8,9"/>
                              </svg>
                            </a>
                          </td>
                          <td className="tender-publish-date">
                            {formatDate(tender.publishDate)}
                          </td>
                          <td className="tender-last-date">
                            {formatDate(tender.lastDate)}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4" className="no-data">
                          {isMarathi() 
                            ? 'या वर्षासाठी कोणतीही निविदा किंवा सूचना उपलब्ध नाही.' 
                            : 'No tenders or notices available for this year.'
                          }
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};

export default TendersNotices;